import script from "./ImageEditor.vue?vue&type=script&lang=ts&setup=true"
export * from "./ImageEditor.vue?vue&type=script&lang=ts&setup=true"

import "./ImageEditor.vue?vue&type=style&index=0&id=9644102a&scoped=true&lang=scss"

import exportComponent from "/var/build/production/construction-site-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9644102a"]])

export default __exports__